
import "../Foundation/stylable/colors.st.css.js";
import "../Text/Text.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_182_0_Breadcrumbs";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_182_0_Breadcrumbs__root","breadcrumbsHover":"wds_1_182_0_Breadcrumbs__breadcrumbsHover","breadcrumbs":"wds_1_182_0_Breadcrumbs__breadcrumbs","item":"wds_1_182_0_Breadcrumbs__item","divider":"wds_1_182_0_Breadcrumbs__divider","itemContainer":"wds_1_182_0_Breadcrumbs__itemContainer"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"color":"var(--wds-color-text-standard-primary, var(--wsr-color-D30, #595D70))","backgroundColor":"var(--wds-breadcrumbs-on-grey-fill-hover, var(--wsr-color-D80, #FFFFFF))","height":"36px","sidePadding":"var(--wds-breadcrumbs-padding-horizontal-large, 14px)"}; 
export var vars = {"wds-breadcrumbs-border-radius":"--wds-breadcrumbs-border-radius","wds-breadcrumbs-on-white-fill-hover":"--wds-breadcrumbs-on-white-fill-hover","wds-breadcrumbs-on-dark-fill-hover":"--wds-breadcrumbs-on-dark-fill-hover","wds-breadcrumbs-text-weight-selected":"--wds-breadcrumbs-text-weight-selected","wds-breadcrumbs-padding-horizontal-small":"--wds-breadcrumbs-padding-horizontal-small","wds-breadcrumbs-padding-horizontal-medium":"--wds-breadcrumbs-padding-horizontal-medium","wds-breadcrumbs-padding-horizontal-large":"--wds-breadcrumbs-padding-horizontal-large","wds-breadcrumbs-on-grey-fill-hover":"--wds-breadcrumbs-on-grey-fill-hover","wds-color-text-standard-primary-light":"--wds-color-text-standard-primary-light","wds-color-text-standard-primary":"--wds-color-text-standard-primary","wds-breadcrumbs-text-weight-default":"--wds-breadcrumbs-text-weight-default","wds-breadcrumbs-font-size-small":"--wds-breadcrumbs-font-size-small","wds-breadcrumbs-text-line-height-small":"--wds-breadcrumbs-text-line-height-small"}; 




